export default __webpack_public_path__ + "static/media/Arrow---Down-2.e803ac45.svg";